import React from 'react'
import AddGateForm from '../../../component/form/master/gate/AddGateForm'

export default function AddGate() {
    return (
        <>
            <div className='container-fluid'>
                <div className="row">
                    <div className="col-md-12">
                        <AddGateForm />
                    </div>
                </div>
            </div>
        </>
    )
}


